import { QueryClient } from "@tanstack/react-query"
import { getCompetitorsFundingAnalysisQuery } from "@/feature/fundraising-advisory/competitors-funding-analysis/api/index.ts"
import { DEFAULT_QUERY_ARGS } from "@/feature/fundraising-advisory/competitors-funding-analysis/constants.ts"

export const getCompetitorsFundingAnalysisLoader =
  (queryClient: QueryClient) => async () => {
    const competitorsFundingAnalysis = queryClient.ensureQueryData(
      getCompetitorsFundingAnalysisQuery({
        ...DEFAULT_QUERY_ARGS,
      })
    )

    return {
      competitorsFundingAnalysis,
    }
  }
